// extracted by mini-css-extract-plugin
export var languages = "navbar-module--languages--M0SWt";
export var active = "navbar-module--active--1TM2D";